import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = true }) {
  const { user, loading, logout } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#1a1a1a] flex items-center justify-center">
        <div className="flex items-center gap-3 text-[#c5a76f]">
          <div className="w-3 h-3 rounded-full bg-[#c5a76f] animate-pulse" />
          <div className="w-3 h-3 rounded-full bg-[#c5a76f] animate-pulse" style={{ animationDelay: "150ms" }} />
          <div className="w-3 h-3 rounded-full bg-[#c5a76f] animate-pulse" style={{ animationDelay: "300ms" }} />
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  if (adminOnly && !user.is_admin)
    return (
      <div className="min-h-screen bg-[#1a1a1a] flex items-center justify-center text-white px-5">
        <div className="text-center max-w-md">
          <h2 className="text-2xl font-bold mb-3" style={{ fontFamily: "'Familjen Grotesk', serif" }}>
            Geen toegang
          </h2>
          <p className="text-white/60 mb-2">U bent niet gemachtigd om dit gedeelte te bekijken.</p>
          <p className="text-white/40 text-sm mb-6">
            Aangemeld als: <span className="text-[#c5a76f] font-mono">{user.email}</span>
          </p>
          <p className="text-white/50 text-xs mb-6">
            Alleen toegestane admin-e-mails kunnen inloggen. Meld u af en log opnieuw in met het juiste Google-account.
          </p>
          <button
            onClick={async () => {
              await logout();
              window.location.href = "/login";
            }}
            data-testid="no-access-logout-button"
            className="px-6 py-3 bg-[#c5a76f] text-black hover:bg-[#d8bd86] transition-colors text-sm font-semibold tracking-widest uppercase rounded"
          >
            Afmelden en opnieuw proberen
          </button>
        </div>
      </div>
    );
  return children;
}
